import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "./root";

export class UserStore {
    hasCheckedAuth: boolean = false;
    user: any = null;
    isAuthorized: boolean = false;
    activeUser: any;
    selectedManager = null;
    userPermissionsAndParts: any = null;
    userDetailsMode: boolean = false;
    addTeam: boolean = false;
    editTeam: boolean = false;
    userId: any = null;
    userList = [];
    userTag = [];
    userProjects = [];
    profile_update: boolean = false;
    profile_open: boolean = false;
    active_device = [];
    add_new_users_modal: boolean = false;
    remove_user_modal: boolean = false;
    ban_user_modal: boolean = false;
    edit_user_modal: boolean = false;
    add_bulk_user: boolean = false;
    active_reportee: boolean = false;
    active_manager: boolean = false;
    selectedReporteeList = [];
    reportees_list: boolean = false;
    SOCIAL_LISTENING_USER_WHITELIST = [1, 12255, 19511, 15580, 9556, 15623];
    add_manager: boolean = false;
    add_reportee: boolean = false;
    delete_Reportee_manager: boolean = false;
    delete_manager: boolean = false;

    thumbnail_modal: boolean = false;
    selected_image: {
        s3Key: string;
        bucket: string;
        width: number;
        height: number;
    } | null = null;
    attachment_image: {
        s3Key: string;
        bucket: string;
        width: number;
        height: number;
    } | null = null;
    rootStore: any;

    constructor(p: RootStore) {
        this.rootStore = p;
        this.isAuthorized = false;
        this.hasCheckedAuth = false;
        this.activeUser = {};
        this.userPermissionsAndParts = {};
        makeAutoObservable(this);
    }

    @computed
    get visibleUserRoles() {
        const role = this.user?.role;

        return [
            { label: "Root", value: "root" },
            { label: "Admin", value: "client" },
            { label: "Super Admin", value: "superadmin" },
            { label: "Party worker", value: "partyworker" },
            { label: "Back office", value: "backoffice" },
            { label: "Field Worker", value: "surveyworker" },
            { label: "QA Worker", value: "qaworker" },
        ].filter((r) => {
            if (r.value === "root" && role !== "root") return false;
            if (r.value === "superadmin" && role !== "root") return false;

            return true;
        });
    }

    @action
    checkLogin = () => {
        const userInfoInLocalStorage = window.localStorage.getItem("__userprofile");
        if (userInfoInLocalStorage && userInfoInLocalStorage != "") {
            // Set both flags atomically to avoid race conditions
            this.user = JSON.parse(userInfoInLocalStorage);
            this.isAuthorized = true;
            this.hasCheckedAuth = true;
            return true;
        } else {
            this.user = null;
            this.isAuthorized = false;
            this.hasCheckedAuth = true;
            return false;
        }
    };

    @action
    getToken() {
        const userInfoInLocalStorage = window.localStorage.getItem("__userprofile");
        if (userInfoInLocalStorage != null) {
            const userInfo = JSON.parse(userInfoInLocalStorage);
            return userInfo.token;
        }
    }

    @action
    async sendOTP(phone: string) {
        const payload = {
            phonenum: phone,
            deviceid: "web:00:browser",
        };
        return await this.rootStore.api.post("user/login", payload);
    }

    // @action
    // async getactivedevices(id) {
    //     return (
    //         await this.rootStore.api.post("user/listdevices"),
    //         {
    //             id,
    //         }
    //     );
    // }

    @action
    async getactivedevices(userid?: number) {
        return await this.rootStore.api.post("user/listdevices", {
            userid,
        });
    }

    @action
    async revokedevices(id: string) {
        return await this.rootStore.api.post("user/revoke-device", {
            id: id,
        });
    }

    // @action
    // async revokeuserdevice(userid: number, id: string) {
    //     return await this.rootStore.api.post("user/revoke-user-device", {
    //         userid: userid,
    //         id: id,
    //     });
    // }

    @action
    async revokeuserdevice(userid: number, ids: string[]) {
        return await this.rootStore.api.post("user/revoke-user-device", {
            userid,
            ids,
        });
    }

    @action
    async logoutall() {
        return await this.rootStore.api.post("user/logoutall");
    }

    @action
    async getUserDevices(userid: number) {
        return await this.rootStore.api.post("user/getuserdevices", {
            userid,
        });
    }

    // @action
    // async sendOTP(phone: string) {
    //     let deviceId = localStorage.getItem("device_id");
    //
    //     if (!deviceId) {
    //         deviceId = crypto.randomUUID();
    //
    //         localStorage.setItem("device_id", deviceId);
    //     }
    //
    //     const payload = {
    //         phonenum: phone,
    //
    //         deviceid: deviceId,
    //
    //         browser: navigator.userAgent,
    //
    //         platform: navigator.platform,
    //
    //         timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    //     };
    //
    //     return await this.rootStore.api.post("user/login", payload);
    // }

    // @action
    // async sendOTP(phone: string) {
    //     let deviceId = localStorage.getItem("device_id");
    //
    //     if (!deviceId) {
    //         deviceId = crypto.randomUUID();
    //         localStorage.setItem("device_id", deviceId);
    //     }
    //
    //     // Device Type
    //     const getDeviceType = () => {
    //         const ua = navigator.userAgent;
    //
    //         if (/Android|iPhone|iPad|iPod/i.test(ua)) {
    //             return "mobile";
    //         }
    //
    //         return "desktop";
    //     };
    //
    //     // Device Name (browser + platform)
    //     const getDeviceName = () => {
    //         return `${navigator.platform} - ${navigator.userAgent}`;
    //     };
    //
    //     // Location
    //     const getLocation = () =>
    //         new Promise((resolve) => {
    //             if (!navigator.geolocation) {
    //                 resolve(null);
    //                 return;
    //             }
    //
    //             navigator.geolocation.getCurrentPosition(
    //                 (position) => {
    //                     resolve({
    //                         latitude: position.coords.latitude,
    //                         longitude: position.coords.longitude,
    //                     });
    //                 },
    //                 () => resolve(null),
    //                 {
    //                     enableHighAccuracy: false,
    //                     timeout: 5000,
    //                 }
    //             );
    //         });
    //
    //     const location = await getLocation();
    //
    //     const payload = {
    //         phonenum: phone,
    //
    //         deviceid: deviceId,
    //
    //         devicetype: getDeviceType(), // mobile / desktop
    //
    //         devicename: getDeviceName(),
    //
    //         browser: navigator.userAgent,
    //
    //         platform: navigator.platform,
    //
    //         timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    //
    //         location,
    //     };
    //
    //     return await this.rootStore.api.post("user/login", payload);
    // }

    @action
    async update_user_from_project(payload) {
        return await this.rootStore.api.post("user/edituser", payload);
    }

    // @action
    // validateOTP = async (phone: string, otp: string) => {
    //     const payload = {
    //         phonenum: phone,
    //         deviceid: "web:00:browser",
    //         otp: otp,
    //     };
    //     try {
    //         const response = await this.rootStore.api.post("user/validateotp", payload);
    //         const profile = response.data;
    //         profile.projects = profile.projects.sort((a: { id: number }, b: { id: number }) => {
    //             return a.id - b.id;
    //         });
    //         if (response.ok) {
    //             await this.saveProfile(profile);
    //             return true;
    //         } else {
    //             await this.checkLogin();
    //             return false;
    //         }
    //     } catch (e) {
    //         await this.checkLogin();
    //         return false;
    //     }
    // };

    @action
    validateOTP = async (phone: string, otp: string) => {
        try {
            let deviceId = localStorage.getItem("device_id");

            if (!deviceId) {
                deviceId = crypto.randomUUID();
                localStorage.setItem("device_id", deviceId);
            }

            const getDeviceType = () => {
                const ua = navigator.userAgent;

                if (/Android|iPhone|iPad|iPod/i.test(ua)) {
                    return "mobile";
                }

                return "desktop";
            };

            const getDeviceName = () => {
                return `${navigator.platform} - ${navigator.userAgent}`;
            };

            const getLocation = () =>
                new Promise<any>((resolve) => {
                    if (!navigator.geolocation) {
                        resolve(null);
                        return;
                    }

                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve({
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                            });
                        },
                        () => resolve(null),
                        {
                            enableHighAccuracy: false,
                            timeout: 5000,
                        }
                    );
                });

            const location = await getLocation();

            const payload = {
                phonenum: phone,
                otp,

                deviceid: deviceId,

                devicetype: getDeviceType(),

                devicename: getDeviceName(),

                browser: navigator.userAgent,

                platform: navigator.platform,

                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

                location,
            };

            const response = await this.rootStore.api.post("user/validateotp", payload);

            const profile = response.data;

            profile.projects =
                profile.projects?.sort((a: { id: number }, b: { id: number }) => a.id - b.id) || [];

            if (response.ok) {
                await this.saveProfile(profile);
                return true;
            }

            await this.checkLogin();
            return false;
        } catch (e) {
            await this.checkLogin();
            return false;
        }
    };

    @action
    saveProfile(profile: any) {
        const userInfo = JSON.stringify(profile);
        this.activeUser = userInfo;
        window.localStorage.setItem("__userprofile", userInfo);
        this.checkLogin();
    }
    @computed
    get isLoggedIn(): boolean {
        return this.isAuthorized;
    }

    @action
    getProjects = async () => {
        const response = await this.rootStore.api.post("project/myprojects", {});
        if (response.status == 200) {
            this.userProjects = response.data;
            return response.data;
        } else return [];
    };

    @action
    setSelectedManager = (manager) => {
        this.selectedManager = manager;
    };

    @action
    getDisplayName = () => {
        try {
            if (this.isLoggedIn) return this.user["name"];
        } catch (e) {}
        return "";
    };

    getLoggedinUserId = () => {
        try {
            if (this.isLoggedIn) return this.user["id"];
        } catch (e) {
            console.log(e);
        }
        return -1;
    };

    @action
    getDisplayRole = () => {
        try {
            if (this.isLoggedIn) {
                const role = this.user["role"];
                switch (role) {
                    case "root":
                        return "Root";
                    case "client":
                        return "Administrator";
                    case "partyworker":
                        return "Party Worker";
                    case "surveyworker":
                        return "Field Worker";
                    case "qaworker":
                        return "QA Specialist";
                }
            }
        } catch (e) {}
        return "";
    };

    @action
    logout = async () => {
        const items_to_remove = [
            "__userprofile",
            "__active_project",
            "pageIndex",
            "currentPage",
            "userpartsandperms",
            "header",
            "timeline",
            "isSigned",
        ];
        items_to_remove.forEach(async (item) => {
            await window.localStorage.removeItem(item);
        });
        this.isAuthorized = false;
    };

    @action
    isRoot = () => {
        try {
            if (this.isLoggedIn) return this.user["role"] === "root";
        } catch (e) {}
        return false;
    };

    @action
    isClient = () => {
        try {
            if (this.isLoggedIn) return this.user["role"] === "client";
        } catch (e) {
            console.log(e);
        }
        return false;
    };

    @action
    isQaworker = () => {
        try {
            if (this.isLoggedIn) return this.user["role"] === "qaworker";
        } catch (e) {
            console.log(e);
        }
        return false;
    };

    @action
    setActiveUser = (user) => {
        this.activeUser = user;
    };

    @action
    setAddManager = (manager) => {
        this.add_manager = manager;
    };

    @action
    setAddReportees = (reportees) => {
        this.add_reportee = reportees;
    };

    @action
    setSelectedReporteeList = (val) => {
        this.selectedReporteeList = val;
    };

    @action
    setReporteesList = (reporteesList) => {
        this.reportees_list = reporteesList;
    };

    @action
    getUserRolesDefinitions = async () => {
        return await this.rootStore.api.post("user/roledefs");
    };

    @action
    set_profile_update(val) {
        this.profile_update = val;
    }

    @action
    set_profile_open(val) {
        this.profile_open = val;
    }

    @action
    set_active_devices(val: any[]) {
        this.active_device = Array.isArray(val) ? val : [];
    }

    @action
    set_add_bulk_user(val) {
        this.add_bulk_user = val;
    }

    @action
    setactiveReportee(val) {
        this.active_reportee = val;
    }

    @action
    setactiveManager(val) {
        this.active_manager = val;
    }

    @action
    set_delete_repor_manager = (val) => {
        this.delete_Reportee_manager = val;
    };

    @action
    set_delete_manager = (val) => {
        this.delete_manager = val;
    };

    @action
    async updateProfile(payload) {
        try {
            return await this.rootStore.api.post("user/updateprofile", payload);
        } catch (error) {
            console.log(error);
        }
    }

    @action
    async add_manager_user(payload) {
        return await this.rootStore.api.post("user_heirarchy/update_manager", payload);
    }

    @action
    async add_reportees_list(payload) {
        return await this.rootStore.api.post("user_heirarchy/update_reportees", payload);
    }

    @action
    async addBulkUser(payload) {
        try {
            return await this.rootStore.api.post("user/bulkinvite", payload);
        } catch (error) {
            console.log(error);
        }
    }

    @action
    async getProfile() {
        try {
            return this.rootStore.api.post("user/me");
        } catch (error) {
            console.log(error);
        }
    }

    @action
    setUserList = (val) => {
        this.userList = val;
    };

    @action
    setUserTag = (val) => {
        this.userTag = val;
    };

    @action
    setEditTeamStatus = (val) => {
        this.editTeam = val;
    };

    @action
    setAddTeamStatus = (val) => {
        this.addTeam = val;
    };

    @action
    async add_Team(payload) {
        try {
            return await this.rootStore.api.post("/project/editprojectproperties", payload);
        } catch (e) {}
    }

    @action
    updateUserHierarchy = async (payload) => {
        return await this.rootStore.api.post("user/updateuserhierarchy", payload);
    };

    @action
    updateUserPermissions = async (payload) => {
        return await this.rootStore.api.post("user/updateuserperms", payload);
    };

    @action
    setUserDetailsMode = (mode) => {
        this.userDetailsMode = mode;
    };

    @action
    setUserId = (val) => {
        this.userId = val;
    };

    @action
    async ban_user(payload) {
        const req_pl = {
            userid: payload["userid"],
            userrole: "",
            issupervisor: false,
        };
        return await this.rootStore.api.post("user/archiveuser", req_pl);
    }

    @action
    async remove_user_from_project(payload) {
        return await this.rootStore.api.post("user/removeuser", payload);
    }

    @action
    async remove_manager_reportees(payload) {
        return await this.rootStore.api.post("user_heirarchy/delete_relation", payload);
    }

    @action
    is_field_worker() {
        try {
            const role = this.user["role"];
            if (role === "surveyworker" || role === "partyworker") return true;
        } catch (e) {
            return false;
        }
        return false;
    }

    @action
    get_user_permissions_and_parts = async (payload) => {
        try {
            const res = await this.rootStore.api.post("user/userrichinfo", payload);
            await this.update_user_permissions_and_parts(res.data);
            return res;
        } catch (e) {
            console.log(e);
        }
    };

    @action
    update_user_permissions_and_parts = (payload) => {
        this.userPermissionsAndParts = payload;

        this.activeUser = {
            ...this.activeUser,
            manager: payload.manager ?? null,
            reportee: payload.reportee ?? [],
        };

        localStorage.setItem("userpartsandperms", JSON.stringify(payload));
    };

    @action
    update_thumbnail_modal(value) {
        this.thumbnail_modal = value;
    }
    set_selected_image = (imageData) => {
        this.selected_image = imageData;
    };

    set_attachment_image = (imageAttach) => {
        this.attachment_image = imageAttach;
    };
    @action
    update_user_store_prop(prop, value) {
        switch (prop) {
            case "add_new_users_modal":
                this.add_new_users_modal = value;
                break;
            case "remove_user_modal":
                this.remove_user_modal = value;
                break;
            case "ban_user_modal":
                this.ban_user_modal = value;
                break;
            case "edit_user_modal":
                this.edit_user_modal = value;
                break;
        }
    }
}
